import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TagPage } from './tag.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'tag',
        component: TagPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [TagPage],
    exports: [TagPage]
})
export class TagPageModule {}
